/**
 * @desc 查询附近的门店信息(野有美)
 */

import { RequestConfig, request } from 'umi';
export interface Params {
  /** 活动筛选 加入的活动ID,多个取交集  */
  activity_filter?: string;
  /** 区CODE */
  area?: string;
  /** 区名 */
  area_name?: string;
  /** 无用参数请忽略 */
  check_p?: string;
  /** 市CODE */
  city?: string;
  /** 市名 */
  city_name?: string;
  /** 通用活动id */
  common_activity_id?: string;
  /** 排除门店ID */
  exclude_store_ids?: string;
  /** 商品类型筛选 1=经典款,2=阿尔法, 3=灵点,4=云白,5=无限,6=小悦刻 */
  goods_type_filter?: string;
  /** 纬度 */
  lat: string;
  /** 经度 */
  lng: string;
  /** 页码 */
  page: string;
  /** 每页行数 不传默认20 */
  page_size?: string;
  /** 省CODE */
  province?: string;
  /** 排序类型 1=智能排序,2=按距离排序 */
  query_sort_type?: string;
  /** 门店ID */
  share_activity_id?: string;
  /** 门店类型筛选  1=专卖店,2=授权店 */
  store_type_filter?: string;
}

function req(params: Params, config: Parameters<typeof request>[1] = {}) {
  return request<defs.store.GeneralHttpResponse<defs.store.StoreNearbyBindVO>>(
    `/storeapi/api/v3/store/nearby/yym`,
    {
      params,
      method: 'get',
      ...(config || {}),
    },
  );
}
req.req = {} as Parameters<typeof req>[0];
req.res = {} as defs.store.GeneralHttpResponse<defs.store.StoreNearbyBindVO>;
export default req;
